import type { Route } from 'vue-router'
import { createDiagnosticEvent, sanitizeDiagnosticUrl } from '@patsnap/synapse_common_utils'
import type { DiagnosticEventSink } from '@patsnap/synapse_common_utils'

let diagnosticEventSink: DiagnosticEventSink | undefined

export function configureDiagnosticRouteSink(sink?: DiagnosticEventSink): void {
  diagnosticEventSink = sink
}

function getRouteName(route: Route): string {
  return route.name || ''
}

export function recordDiagnosticRoute(from: Route, to: Route): void {
  if (!diagnosticEventSink) return
  try {
    diagnosticEventSink(
      createDiagnosticEvent('route', {
        fromName: getRouteName(from),
        fromPath: sanitizeDiagnosticUrl(from.fullPath),
        toName: getRouteName(to),
        toPath: sanitizeDiagnosticUrl(to.fullPath),
        completedAt: Date.now(),
      })
    )
  } catch {
    // Diagnostics must not alter navigation completion.
  }
}
